@if (header()) {
  <ng-container *ngTemplateOutlet="header()" />
} @else {
  @if (headerLabel()) {
    <prime-simple-yes-no-header
      (onClose)="cancelHandler()"
      [label]="headerLabel()"
    />
  }
}

@if (content()) {
  <ng-container *ngTemplateOutlet="content()" />
}

@if (footer()) {
  <ng-container *ngTemplateOutlet="footer()" />
} @else {
  <prime-simple-yes-no-footer
    (onCancel)="cancelHandler()"
    (onConfirm)="confirmHandler()"
    [cancelButtonLabel]="cancelButtonLabel()"
    [closeOnCancel]="closeOnCancel()"
    [confirmButtonDisabledStreamManager]="confirmButtonDisabledStreamManager() ?? null"
    [confirmButtonLabel]="confirmButtonLabel()"
    [justifyPosition]="justifyPosition()"
  />
}
